import { CSS_PROPERTY, getCssBasedOnRtl, media } from '../../styles';
import styled from 'styled-components';

type ListItemProps = {
  addMargin?: boolean;
  showBulletPoints?: boolean;
};

type ListProps = {
  noPadding?: boolean;
};

export const ListItem = styled.li<ListItemProps>`
  list-style: ${({ showBulletPoints }) => (showBulletPoints ? 'initial' : 'none')};
  margin: ${({ addMargin, theme }) => (addMargin ? `0 ${theme.spacing.base.md}` : '0')};
  max-width: 100%;
`;

export const List = styled.ul<ListProps>`
  max-width: 100%;
  padding: ${({ noPadding, theme }) => (noPadding ? '0' : `0 ${theme.spacing.base.md}`)};
  margin: 0;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${({ theme }) => theme.typography.size.medium};
  height: 100%;
  justify-content: space-between;
  width: 100%;
`;

export const Border = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.typography.color.tertiary};
  margin-bottom: ${({ theme }) => theme.spacing.base.sm};
  width: 100%;
`;

export const Link = styled.a`
  color: ${({ theme }) => theme.ui.links.fontColor};
  display: flex;
  font-size: ${({ theme }) => theme.typography.size.small};
  word-break: break-word;

  &:focus-visible {
    outline-style: auto;
    outline-width: 5px;
  }
`;

export const Section = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.base.md};
  width: 100%;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.typography.color.secondary};
  font-size: ${({ theme }) => theme.typography.size.small};
  font-weight: ${({ theme }) => theme.typography.weight.regular};
  padding-bottom: ${({ theme }) => theme.spacing.base.xxs};
`;

export const BodyText = styled.div<{ noPadding?: boolean }>`
  color: ${({ theme }) => theme.typography.color.primary};
  padding-bottom: ${({ noPadding, theme }) => (noPadding ? '0px' : theme.spacing.base.xs)};
  text-overflow: ellipsis;
`;

export const LinkIconContainer = styled.div`
  height: 15px;
  ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.MARGIN_RIGHT, theme.spacing.base.xxs)};
  padding-top: ${({ theme }) => theme.spacing.base.xxs};
  width: 15px;

  ${media.mobilePortrait} {
    svg {
      height: 15px;
      width: 15px;
    }
  }
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
`;

export const Item = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.color.neutral.default};
  border: solid ${({ theme }) => theme.typography.color.tertiary} 1px;
  border-radius: 4px;
  color: ${({ theme }) => theme.typography.color.primary};
  display: flex;
  font-size: ${({ theme }) => theme.typography.size.medium};
  min-height: 32px;
  ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.MARGIN_RIGHT, theme.spacing.base.xs)};
  margin-bottom: ${({ theme }) => theme.spacing.base.xs};
  max-width: 100%;
  padding: ${({ theme }) => theme.spacing.base.xs};
  word-break: break-word;

  ${media.mobilePortrait} {
    ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.MARGIN_RIGHT, theme.spacing.mobile.xl)};
    margin-bottom: ${({ theme }) => theme.spacing.base.sm};
  }
`;

export const HistoryTableWrapper = styled.div`
  border: solid ${({ theme }) => theme.typography.color.tertiary} 1px;
  border-radius: 3px;
  display: flex;
  flex-wrap: wrap;
`;

export const HistoryTableHeaderWrapper = styled.div`
  background-color: ${({ theme }) => theme.color.neutral.default};
  display: flex;
  flex-direction: row;
  padding-top: ${({ theme }) => theme.spacing.base.xs};
  padding-bottom: ${({ theme }) => theme.spacing.base.xs};
  ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.PADDING_RIGHT, 0)};
  ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.PADDING_LEFT, theme.spacing.base.sm)};
  width: 100%;
`;

export const HistoryTableHeaderItem = styled.div`
  width: 50%;
`;

export const HistoryTableItemWrapper = styled.div`
  border-top: solid ${({ theme }) => theme.typography.color.tertiary} 1px;
  display: flex;
  padding-top: ${({ theme }) => theme.spacing.base.xs};
  padding-bottom: ${({ theme }) => theme.spacing.base.xs};
  ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.PADDING_LEFT, theme.spacing.base.sm)};
  width: 100%;
`;

export const HistoryTableItem = styled.div`
  align-items: center;
  display: flex;
  width: 50%;
`;

export const GreenCircle = styled.div`
  border: 2px solid green;
  border-radius: 50%;
  display: flex;
  height: 12px;
  ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.MARGIN_RIGHT, theme.spacing.base.xxs)};
  width: 12px;
  min-width: 12px;
`;

export const RedCircle = styled.div`
  border: 2px solid red;
  border-radius: 50%;
  display: flex;
  height: 12px;
  ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.MARGIN_RIGHT, theme.spacing.base.xxs)};
  width: 12px;
  min-width: 12px;
`;

export const ListContainer = styled.div`
  position: relative;
`;

export const ListWrapper = styled.div`
  position: relative;
  z-index: 1;
`;
